export default __webpack_public_path__ + "static/media/link_2.56e99817.png";